import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormGroup } from 'react-bootstrap';
import { List, ListItem } from 'material-ui/List';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import firebase from '../firebase/firebase';
import { setDocument } from '../components/document-editor/editor_actions';

class DocumentSearchModal extends Component {
    constructor() {
        super();

        this.state = {
            searchTerm: '',
            documents: [],
            selectedDocument: null
        };

        this.handleQueryChange = this.handleQueryChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.updateDocumentList = this.updateDocumentList.bind(this);
        this.handleSelectingDocument = this.handleSelectingDocument.bind(this);
        this.handleDocumentDownload = this.handleDocumentDownload.bind(this);
        this.handleEditDocument = this.handleEditDocument.bind(this);
    }

    handleSearch(event) {
        event.preventDefault();

        const queryRef = firebase.database().ref('document-search').push();
        queryRef.set({
            query: this.state.searchTerm
        });
        queryRef.on('value', snapshot => {
            const data = snapshot.val();
            if (data.results) {
                this.updateDocumentList(data.results);
            }
        });
    }

    handleQueryChange(event) {
        this.setState({
            searchTerm: event.target.value
        });
    }

    updateDocumentList(documents) {
        this.setState({
            documents,
        });
    }

    createDocumentList(documents) {
        var docList = documents.map(doc => {
            return <ListItem key={doc._id}
                onClick={() => this.handleSelectingDocument(doc)}>
                {doc._source.title}
            </ListItem>
        });

        return docList;
    }

    handleSelectingDocument(document) {
        this.setState({
            selectedDocument: document._source.name
        });
    }

    handleDocumentDownload() {
        const { selectedDocument } = this.state;
        firebase.database().ref(`static-documents/${selectedDocument}`)
            .once('value')
            .then(snapshot => {
                const filename = snapshot.val().storage_url;
                firebase.storage().ref(filename).getDownloadURL().then(url => {
                    fetch(url)
                        .then(response => response.blob())
                        .then(blob => URL.createObjectURL(blob))
                        .then(url => {
                            window.open(url, '_blank');
                        });
                });
            });
    }

    handleEditDocument() {
        const { selectedDocument } = this.state;
        this.props.setDocumentForEditing(selectedDocument);
        this.props.history.push('/documents');
        this.props.onClose();
    }

    render() {
        const { showModal, onClose } = this.props;
        const { documents, selectedDocument } = this.state;
        const docList = this.createDocumentList(documents);

        const style = {
            marginRight: 12,
        };

        return (
            <Dialog
              open={showModal}
              onRequestClose={onClose}
              title="Document Search"
              style={{ marginTop: -100}}
            >
                <form onSubmit={this.handleSearch}>
                    <FormGroup>
                        <TextField
                            type="text"
                            hintText="Enter search term"
                            value={this.state.searchTerm}
                            onChange={this.handleQueryChange} />
                    </FormGroup>
                    <RaisedButton type="submit">Lookup</RaisedButton>
                </form>
                <List>
                    {docList}
                </List>
                {
                    (selectedDocument) ?
                        <div>
                            <RaisedButton style={style} primary={true} onClick={this.handleEditDocument}>
                                Edit
                            </RaisedButton>
                            <RaisedButton style={style} secondary={true} onClick={this.handleDocumentDownload}>
                                Download
                            </RaisedButton>
                        </div> :
                        null
                }

            </Dialog>
        );
    }
};

const mapStateToProps = (state, ownProps) => {
    return {
        showModal: ownProps.showModal,
        onClose: ownProps.onClose
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        setDocumentForEditing: (selectedDocument) => dispatch(setDocument(selectedDocument))
    };
};

export default withRouter(connect(null, mapDispatchToProps)(DocumentSearchModal));



// WEBPACK FOOTER //
// ./src/common/documentSearchModal.jsx